<template>
  <section>
    <div class="header" style="height: 65px;"></div>
    <img src="http://video.naolamp.com/officialWeb/install/install_qrcode.jpg" alt="">
  </section>
</template>

<script>
export default {
  name: 'scanInstall'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/install/scanInstall.vue